// src/components/user/HeroSection.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCheckCircle } from 'react-icons/fa';

const HeroSection = () => {
  return (
    <section className="relative pt-20 pb-32 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900 to-gray-900">
        <div className="absolute inset-0 bg-black opacity-50"></div>
      </div>

      <div className="container-custom relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-white fade-in">
            <h1 className="text-5xl font-bold mb-6 leading-tight">
              Engineering Excellence & 
              <span className="text-blue-400"> Industrial Solutions</span>
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Brasotech Investments Limited specializes in Civil, Mechanical, and Electrical 
              Engineering services, delivering quality projects across Zambia and Africa.
            </p>
            
            <div className="mb-8 space-y-3">
              <div className="flex items-center space-x-2">
                <FaCheckCircle className="h-5 w-5 text-green-400" />
                <span>Registered with PACRA, ZRA, ZPPA, NCC</span>
              </div>
              <div className="flex items-center space-x-2">
                <FaCheckCircle className="h-5 w-5 text-green-400" />
                <span>15+ Years of Industry Experience</span>
              </div>
              <div className="flex items-center space-x-2">
                <FaCheckCircle className="h-5 w-5 text-green-400" />
                <span>Certified Engineering Professionals</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <Link
                to="/services"
                className="bg-blue-600 text-white px-8 py-3 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center space-x-2"
              >
                <span>Our Services</span>
                <FaArrowRight />
              </Link>
              <Link
                to="/contact"
                className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-lg hover:bg-white hover:text-gray-900 transition-colors duration-200"
              >
                Contact Us
              </Link>
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 gap-6">
            <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20">
              <div className="text-4xl font-bold text-white mb-2">15+</div>
              <div className="text-gray-300">Years Experience</div>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20">
              <div className="text-4xl font-bold text-white mb-2">200+</div>
              <div className="text-gray-300">Projects Completed</div>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20">
              <div className="text-4xl font-bold text-white mb-2">50+</div>
              <div className="text-gray-300">Satisfied Clients</div>
            </div>
            <div className="bg-white bg-opacity-10 backdrop-blur-lg rounded-xl p-6 border border-white border-opacity-20">
              <div className="text-4xl font-bold text-white mb-2">6</div>
              <div className="text-gray-300">Certifications</div>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default HeroSection;